import { render } from "./GlobalFooter.vue?vue&type=template&id=65332a5c&scoped=true"
import script from "./GlobalFooter.vue?vue&type=script&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&lang=js"

import "./GlobalFooter.vue?vue&type=style&index=0&id=65332a5c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65332a5c"]])

export default __exports__